import { useUser } from './useUser';
import { isAdminRole, ROLE_LABELS } from '@/lib/auth';
import type { RoleType } from '@/lib/database.types';

export function useRole(): {
  role: RoleType | null;
  label: string | null;
  isAdmin: boolean;
  loading: boolean;
} {
  const { metadata, loading } = useUser();
  const role = metadata?.role ?? null;
  return {
    role,
    label: role ? ROLE_LABELS[role] : null,
    isAdmin: isAdminRole(role),
    loading,
  };
}
